export const ACCESS_TYPE = {
  PUBLIC: 'public',
  MEMBER: 'member',
  GUEST: 'guest',
  SECRET: 'secret',
  PASSWORD: 'password',
} as const;

export type ACCESS_TYPE_KEY = keyof typeof ACCESS_TYPE;

export type ACCESS_TYPE_VALUE = typeof ACCESS_TYPE[ACCESS_TYPE_KEY];

export const ACCESS_TYPE_MAP = {
  [ACCESS_TYPE.PUBLIC]: '전체공개',
  [ACCESS_TYPE.MEMBER]: '멤버만',
  [ACCESS_TYPE.GUEST]: '손님',
  [ACCESS_TYPE.SECRET]: '비공개',
  [ACCESS_TYPE.PASSWORD]: '보호글',
};

export const selectedAccessList = [
  {
    key: ACCESS_TYPE.PUBLIC,
    value: ACCESS_TYPE_MAP[ACCESS_TYPE.PUBLIC],
  },
  {
    key: ACCESS_TYPE.MEMBER,
    value: ACCESS_TYPE_MAP[ACCESS_TYPE.MEMBER],
  },
  {
    key: ACCESS_TYPE.GUEST,
    value: ACCESS_TYPE_MAP[ACCESS_TYPE.GUEST],
  },
  {
    key: ACCESS_TYPE.SECRET,
    value: ACCESS_TYPE_MAP[ACCESS_TYPE.SECRET],
  },
];

export const AccessTooltipMsgMap = {
  [ACCESS_TYPE.SECRET]: '비밀글',
  [ACCESS_TYPE.MEMBER]: '멤버 열람',
  [ACCESS_TYPE.GUEST]: '손님 열람',
  [ACCESS_TYPE.PASSWORD]: '비밀번호 열람',
};
